import { FC, useState } from 'react';
import { useToggle } from 'react-use';

// components
import { PlaceholdersTable } from './PlaceholdersTable';
import InputSearch from 'shared/components/Inputs/InputSearch';
import ButtonDefault from 'shared/components/Buttons/ButtonsDefault';
import { PlaceholderDialog } from './PlaceholderDialog';

// icons
import { ReactComponent as Plus } from 'assets/image/plus.svg';

// styles
import styles from './Placeholders.module.scss';

export const Placeholders: FC = () => {
	const [openPlaceholderDialog, togglePlaceholderDialog] = useToggle(false);
	const [search, setSearch] = useState('');

	return (
		<section className={styles.placeholders}>
			<div className={styles.placeholders_head}>
				<InputSearch placeholder="Search..." classList={['big']} changeHandler={value => setSearch(value)} />
				<ButtonDefault
					title="Create"
					classList={['primary', 'sm']}
					clickHandler={togglePlaceholderDialog}
					icon={<Plus style={{ width: '16px', height: '16px' }} />}
				/>
			</div>
			<PlaceholdersTable search={search} />

			{openPlaceholderDialog ? (
				<PlaceholderDialog open={openPlaceholderDialog} onClose={togglePlaceholderDialog} />
			) : null}
		</section>
	);
};
